import { jsxs as d, jsx as t } from "react/jsx-runtime";
import { c as h } from "./index-CYpVUGdk.js";
import { $ as o } from "./utils-CTvPli9r.js";
import { forwardRef as m, useState as v, useRef as y } from "react";
import { Button as u } from "./button.js";
import { Avatar as w, AvatarImage as N, AvatarFallback as C } from "./avatar.js";
import { Textarea as B } from "./textarea.js";
import { X as f } from "./x-Bns8qHU3.js";
import { c as M } from "./createLucideIcon-Bs_bgX_W.js";
function k() {
  return /* @__PURE__ */ d(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      className: "text-foreground",
      children: [
        /* @__PURE__ */ t("circle", { cx: "4", cy: "12", r: "2", fill: "currentColor", children: /* @__PURE__ */ t(
          "animate",
          {
            id: "spinner_qFRN",
            begin: "0;spinner_OcgL.end+0.25s",
            attributeName: "cy",
            calcMode: "spline",
            dur: "0.6s",
            values: "12;6;12",
            keySplines: ".33,.66,.66,1;.33,0,.66,.33"
          }
        ) }),
        /* @__PURE__ */ t("circle", { cx: "12", cy: "12", r: "2", fill: "currentColor", children: /* @__PURE__ */ t(
          "animate",
          {
            begin: "spinner_qFRN.begin+0.1s",
            attributeName: "cy",
            calcMode: "spline",
            dur: "0.6s",
            values: "12;6;12",
            keySplines: ".33,.66,.66,1;.33,0,.66,.33"
          }
        ) }),
        /* @__PURE__ */ t("circle", { cx: "20", cy: "12", r: "2", fill: "currentColor", children: /* @__PURE__ */ t(
          "animate",
          {
            id: "spinner_OcgL",
            begin: "spinner_qFRN.begin+0.2s",
            attributeName: "cy",
            calcMode: "spline",
            dur: "0.6s",
            values: "12;6;12",
            keySplines: ".33,.66,.66,1;.33,0,.66,.33"
          }
        ) })
      ]
    }
  );
}
const E = h("group relative flex max-w-[60%] items-end gap-2", {
  variants: {
    variant: {
      received: "self-start",
      sent: "flex-row-reverse self-end"
    },
    layout: {
      default: "",
      ai: "w-full max-w-full items-center"
    }
  },
  defaultVariants: {
    variant: "received",
    layout: "default"
  }
}), A = m(
  ({ className: e, variant: a, layout: s, children: l, ...r }, i) => /* @__PURE__ */ t(
    "div",
    {
      className: o(E({ variant: a, layout: s, className: e }), "relative group"),
      ref: i,
      ...r,
      children: l
    }
  )
);
A.displayName = "ChatBubble";
const G = ({ src: e, fallback: a, className: s }) => /* @__PURE__ */ d(w, { className: s, children: [
  /* @__PURE__ */ t(N, { src: e, alt: "Avatar" }),
  /* @__PURE__ */ t(C, { children: a })
] }), L = h("p-4", {
  variants: {
    variant: {
      received: "rounded-r-lg rounded-tl-lg bg-secondary text-secondary-foreground",
      sent: "rounded-l-lg rounded-tr-lg bg-primary text-primary-foreground"
    },
    layout: {
      default: "",
      ai: "w-full rounded-none border-t bg-transparent"
    }
  },
  defaultVariants: {
    variant: "received",
    layout: "default"
  }
}), _ = m(
  ({ className: e, variant: a, layout: s, isLoading: l = !1, children: r, ...i }, n) => /* @__PURE__ */ t(
    "div",
    {
      className: o(
        L({ variant: a, layout: s, className: e }),
        "break-words max-w-full whitespace-pre-wrap"
      ),
      ref: n,
      ...i,
      children: l ? /* @__PURE__ */ t("div", { className: "flex items-center space-x-2", children: /* @__PURE__ */ t(k, {}) }) : r
    }
  )
);
_.displayName = "ChatBubbleMessage";
const J = ({ timestamp: e, className: a, ...s }) => /* @__PURE__ */ t("div", { className: o("text-xs mt-2 text-right", a), ...s, children: e }), K = ({
  icon: e,
  onClick: a,
  className: s,
  variant: l = "ghost",
  size: r = "icon",
  ...i
}) => /* @__PURE__ */ t(u, { variant: l, size: r, className: s, onClick: a, ...i, children: e }), Q = ({ variant: e, className: a, children: s }) => /* @__PURE__ */ t(
  "div",
  {
    className: o(
      "absolute top-1/2 -translate-y-1/2 flex opacity-0 group-hover:opacity-100 transition-opacity duration-200",
      e === "sent" ? "-left-1 -translate-x-full flex-row-reverse" : "-right-1 translate-x-full",
      a
    ),
    children: s
  }
), z = m(
  ({ className: e, value: a, onKeyDown: s, onChange: l, placeholder: r, ...i }, n) => /* @__PURE__ */ t(
    B,
    {
      autoComplete: "off",
      value: a,
      ref: n,
      onKeyDown: s,
      onChange: l,
      name: "message",
      placeholder: r,
      className: o(
        "max-h-12 px-4 py-3 bg-background text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 w-full rounded-md flex items-center h-16 resize-none",
        e
      ),
      ...i
    }
  )
);
z.displayName = "ChatInput";
const F = m(
  ({ className: e, children: a, ...s }, l) => /* @__PURE__ */ t(
    "div",
    {
      className: o("flex flex-col w-full h-full p-4 gap-6 overflow-y-auto", e),
      ref: l,
      ...s,
      children: a
    }
  )
);
F.displayName = "ChatMessageList";
/**
 * @license lucide-react v0.508.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const R = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }]
], j = M("message-circle", R), c = {
  dimensions: {
    sm: "sm:max-w-sm sm:max-h-[500px]",
    md: "sm:max-w-md sm:max-h-[600px]",
    lg: "sm:max-w-lg sm:max-h-[700px]",
    xl: "sm:max-w-xl sm:max-h-[800px]",
    full: "sm:w-full sm:h-full"
  },
  positions: {
    "bottom-right": "bottom-5 right-5",
    "bottom-left": "bottom-5 left-5"
  },
  chatPositions: {
    "bottom-right": "sm:bottom-[calc(100%+10px)] sm:right-0",
    "bottom-left": "sm:bottom-[calc(100%+10px)] sm:left-0"
  },
  states: {
    open: "pointer-events-auto opacity-100 visible scale-100 translate-y-0",
    closed: "pointer-events-none opacity-0 invisible scale-100 sm:translate-y-5"
  }
}, I = ({
  className: e,
  position: a = "bottom-right",
  size: s = "md",
  icon: l,
  children: r,
  ...i
}) => {
  const [n, g] = v(!1), x = y(null), p = () => g(!n);
  return /* @__PURE__ */ d("div", { className: o(`fixed ${c.positions[a]} z-50`, e), ...i, children: [
    /* @__PURE__ */ d(
      "div",
      {
        ref: x,
        className: o(
          "flex flex-col bg-background border sm:rounded-lg shadow-md overflow-hidden transition-all duration-250 ease-out sm:absolute sm:w-[90vw] sm:h-[80vh] fixed inset-0 w-full h-full sm:inset-auto",
          c.chatPositions[a],
          c.dimensions[s],
          n ? c.states.open : c.states.closed,
          e
        ),
        children: [
          r,
          /* @__PURE__ */ t(u, { variant: "ghost", size: "icon", className: "absolute right-2 top-2 sm:hidden", onClick: p, children: /* @__PURE__ */ t(f, { className: "size-4" }) })
        ]
      }
    ),
    /* @__PURE__ */ t(b, { icon: l, isOpen: n, toggleChat: p })
  ] });
};
I.displayName = "ExpandableChat";
const O = ({ className: e, ...a }) => /* @__PURE__ */ t("div", { className: o("flex items-center justify-between p-4 border-b", e), ...a });
O.displayName = "ExpandableChatHeader";
const S = ({ className: e, ...a }) => /* @__PURE__ */ t("div", { className: o("flex-grow overflow-y-auto", e), ...a });
S.displayName = "ExpandableChatBody";
const T = ({ className: e, ...a }) => /* @__PURE__ */ t("div", { className: o("border-t p-4", e), ...a });
T.displayName = "ExpandableChatFooter";
const b = ({
  className: e,
  icon: a,
  isOpen: s,
  toggleChat: l,
  ...r
}) => /* @__PURE__ */ t(
  u,
  {
    variant: "default",
    onClick: l,
    className: o(
      "w-14 h-14 rounded-full shadow-md flex items-center justify-center hover:shadow-lg hover:shadow-black/30 transition-all duration-300",
      e
    ),
    ...r,
    children: s ? /* @__PURE__ */ t(f, { className: "size-6" }) : a || /* @__PURE__ */ t(j, { className: "size-6" })
  }
);
b.displayName = "ExpandableChatToggle";
export {
  A as C,
  I as E,
  k as M,
  G as a,
  _ as b,
  J as c,
  K as d,
  Q as e,
  z as f,
  F as g,
  O as h,
  S as i,
  T as j
};
//# sourceMappingURL=expandable-chat-hsF4FM9n.js.map
